<template>
  <div class="main-page">
    <AboutPage
      v-intersect:about="onIntersect"
      id="about-page-section"
    ></AboutPage>
    <SkillsAndToolsPage
      v-intersect:projects="onIntersect"
      id="skills-and-tools-page-section"
    ></SkillsAndToolsPage>
    <CareerPage
      v-intersect:carrer="onIntersect"
      id="career-page-section"
    ></CareerPage>
    <ContactPage
      v-intersect:contact="onIntersect"
      id="contact-page-section"
    ></ContactPage>
  </div>
</template>

<script>
import CareerPage from "../CareerPage/CareerPage.vue";
import ContactPage from "../ContactPage/ContactPage.vue";
import AboutPage from "../AboutPage/AboutPage.vue";
import SkillsAndToolsPage from "../SkillsAndToolsPage/SkillsAndToolsPage.vue";

export default {
  name: "MainPage",

  data() {
    return {
      isIntersecting: false,
    };
  },
  components: { AboutPage, SkillsAndToolsPage, ContactPage, CareerPage },
  methods: {
    onIntersect(entries, observer, page) {
      switch (page) {
        case "about":
          this.$router.push({ name: page }).catch(() => {});
          break;
        case "skillsAndTools":
          this.$router.push({ name: page }).catch(() => {});
          break;
        case "carrer":
          this.$router.push({ name: page }).catch(() => {});
          break;
        case "contact":
          this.$router.push({ name: page }).catch(() => {});
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
